export const defaultTheme = {
  colors: {
    ink: '#111827',
    inkSoft: '#344054',
    muted: '#667085',
    canvas: '#f4f6f8',
    surface: '#ffffff',
    surfaceAlt: '#f9fafb',
    line: '#e4e7ec',
    gold: '#f3c969',
    mint: '#62c5a7',
    blue: '#5b8def',
    coral: '#ef806e',
    violet: '#9979dc',
    danger: '#d94c4c'
  },
  type: {
    xs: '0.75rem',
    sm: '0.875rem',
    base: '1rem',
    lg: '1.125rem',
    xl: '1.375rem',
    display: 'clamp(1.8rem, 4vw, 3.1rem)'
  },
  space: {
    1: '0.25rem',
    2: '0.5rem',
    3: '0.75rem',
    4: '1rem',
    5: '1.5rem',
    6: '2rem',
    8: '3rem'
  },
  radii: {
    sm: '8px',
    md: '14px',
    lg: '20px',
    pill: '999px'
  },
  shadows: {
    sm: '0 1px 2px rgba(16,24,40,.06)',
    md: '0 12px 30px rgba(16,24,40,.09)',
    focus: '0 0 0 4px rgba(91,141,239,.18)'
  }
};

export function applyTheme(theme = defaultTheme) {
  const root = document.documentElement;
  Object.entries(theme.colors).forEach(([key, value]) => root.style.setProperty(`--color-${key}`, value));
  Object.entries(theme.type).forEach(([key, value]) => root.style.setProperty(`--type-${key}`, value));
  Object.entries(theme.space).forEach(([key, value]) => root.style.setProperty(`--space-${key}`, value));
  Object.entries(theme.radii).forEach(([key, value]) => root.style.setProperty(`--radius-${key}`, value));
  Object.entries(theme.shadows).forEach(([key, value]) => root.style.setProperty(`--shadow-${key}`, value));
}